import { render, staticRenderFns } from "./index.vue?vue&type=template&id=44084b94&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44084b94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44084b94')) {
      api.createRecord('44084b94', component.options)
    } else {
      api.reload('44084b94', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=44084b94&scoped=true", function () {
      api.rerender('44084b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Skill/index.vue"
export default component.exports